@use "~theme/breakpoints";
@use "~theme/typography";

.dateContainer {
  background-color: var(--white);
  padding: 20px;
  width: 100%;
}

.officeSection {
  padding: 14px 14px 24px;
}

.mobileView {
  @include breakpoints.desktop {
    display: none;
  }
}

.noAvailableDoctors {
  @include typography.body;
  color: var(--blue-02);
}
